import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import cx from 'classnames';
import { Button } from 'reactstrap';
import { IconPlus } from '@sfx/icons';
import Collapse from '../../../Basic/Collapse';
import { SearchInput } from '../../../Basic/Input';
import CommonLoad from '../../../Basic/Spin';
import UserTable from './userTable.component';
import UserModal from './assignUserModal.component';
import { isIncluded } from '../../utils/utils';
import { getSolutionsInfoApi } from '../../api/solutionManagement.api';
var Panel = Collapse.Panel;

var SolutionManagement = /*#__PURE__*/function (_Component) {
  _inherits(SolutionManagement, _Component);

  var _super = _createSuper(SolutionManagement);

  function SolutionManagement() {
    var _this;

    _classCallCheck(this, SolutionManagement);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showLoading: false,
      solutions: [],
      searchText: '',
      showModal: false,
      modalMode: 'add',
      editUserInfo: {}
    });

    _defineProperty(_assertThisInitialized(_this), "getSolutions", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var solutions;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                showLoading: true
              });

              _context.prev = 1;
              _context.next = 4;
              return getSolutionsInfoApi();

            case 4:
              solutions = _context.sent;

              _this.setState({
                solutions: solutions
              });

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);

            case 11:
              _this.setState({
                showLoading: false
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function () {
      _this.setState(function (prev) {
        return {
          showModal: !prev.showModal
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addUser", function () {
      _this.setState({
        showModal: true,
        modalMode: 'add',
        editUserInfo: {}
      });
    });

    _defineProperty(_assertThisInitialized(_this), "editUser", function (userInfo) {
      _this.setState({
        showModal: true,
        modalMode: 'edit',
        editUserInfo: userInfo
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateUserNum", function (solId, num) {
      var newSolutions = _this.state.solutions.map(function (value) {
        return value.id === solId ? _objectSpread(_objectSpread({}, value), {}, {
          totalUsers: num
        }) : value;
      });

      _this.setState({
        solutions: newSolutions
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onOperationSuccess", function (solId) {
      var newSolutions = _this.state.solutions.map(function (value) {
        return value.id === solId ? _objectSpread(_objectSpread({}, value), {}, {
          forceRefresh: (value.forceRefresh || 0) + 1
        }) : value;
      });

      _this.setState({
        showModal: false,
        editUserInfo: {},
        solutions: newSolutions
      });
    });

    return _this;
  }

  _createClass(SolutionManagement, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getSolutions();
    } // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState = function () {
        return;
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          prefix = _this$props.prefix,
          translate = _this$props.translate;
      var _this$state = this.state,
          showLoading = _this$state.showLoading,
          solutions = _this$state.solutions,
          searchText = _this$state.searchText,
          showModal = _this$state.showModal,
          modalMode = _this$state.modalMode,
          editUserInfo = _this$state.editUserInfo;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-content-wrap ").concat(prefix, "-content-user ").concat(prefix, "-content-solution")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-content-wrap-option-handle ").concat(prefix, "-operation-area")
      }, /*#__PURE__*/React.createElement(SearchInput, {
        placeholder: translate('SFxAccountSettingsSolutionsSearchInput'),
        onSearchClick: function onSearchClick(value) {
          return _this2.setState({
            searchText: value
          });
        }
      }), /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        size: "sm",
        className: "assign-btn",
        onClick: this.addUser
      }, /*#__PURE__*/React.createElement(IconPlus, {
        size: "18"
      }), "\xA0", translate('SFxAccountSettingsAssignUserButtonText'))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-content-wrap-table ").concat(prefix, "-content-wrap-list")
      }, showLoading && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-mask")
      }, /*#__PURE__*/React.createElement(CommonLoad, {
        size: 0.2
      })), /*#__PURE__*/React.createElement(Collapse, {
        accordion: true
      }, solutions.map(function (sol) {
        return /*#__PURE__*/React.createElement(Panel, {
          className: cx('solution-panel', {
            hide: !isIncluded(sol.name, searchText)
          }),
          key: sol.id,
          activeKey: sol.id,
          canExpand: sol.totalUsers > 0,
          contentClassName: "panel-content",
          header: function header() {
            return /*#__PURE__*/React.createElement(React.Fragment, null, sol.name, /*#__PURE__*/React.createElement("span", {
              className: "header-user"
            }, sol.totalUsers, " ", sol.totalUsers < 2 ? translate('SFxAccountSettingsUserText') : translate('SFxAccountSettingsUsersText')));
          }
        }, function (isOpen) {
          return /*#__PURE__*/React.createElement(UserTable, {
            isOpen: isOpen,
            solutionId: sol.id,
            solutionName: sol.name,
            hasSubscription: sol.hasSubscription,
            totalNum: sol.totalUsers,
            onEditUser: _this2.editUser,
            updateNum: function updateNum(num) {
              return _this2.updateUserNum(sol.id, num);
            },
            forceRefresh: sol.forceRefresh || 0,
            translate: translate
          });
        });
      }))), showModal && /*#__PURE__*/React.createElement(UserModal, {
        translate: translate,
        prefix: prefix,
        isOpen: showModal,
        onToggle: this.toggleModal,
        mode: modalMode,
        userInfo: editUserInfo,
        onSuccess: this.onOperationSuccess
      }));
    }
  }]);

  return SolutionManagement;
}(Component);

export default SolutionManagement;